module.exports = __webpack_public_path__ + "img/bgImg.f491998e.png";